import React from 'react';
import CategoryList from './component/categoryList';


const CategoryManagement: React.FC = () => {

  return (
    <div>
      <CategoryList />
    </div>
  );
};

export default CategoryManagement;
